exports.findAllChildren = (allRows, ids) => {
	if (!ids.length) {
		return [];
	}
	const childIds = allRows.filter(row => row.parentId && ids.includes(row.parentId)).map(row => row.id);

	return [...childIds, ...exports.findAllChildren(allRows, childIds)];
};
